import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';
import gap from 'MOBILE/Gap.js';

import "LIBS/jquery.showhtml.js";
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

// define EVENTs
import Events from "HSNDIR/Events.js";

/**
* class HSN.SignInModal
    
**/
HSN.SignInModal = (function (parent) {
    __extends(SignInModal, parent);

    var modalCallback;

    function SignInModal() {
        var modal = SignInModal.__super__.constructor.call(this, "sign-in-modal");

        this.name = 'HSN.SignInModal';
        this.Close.off();//remove existing handler, have our own
        this.application = HSN.Instance();
        this.deviceInformation = HSN.Instance().DeviceInformation;
        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function () {
            closeModal(modal);
        });

        modal.application.Events.On(Events.Widget.Signin.FORGOT_PASSWORD_INITIATED, function (data) {
            var forgotPasswordUrl = '/account/forgot-password-verify';
            if (modal.deviceInformation.IsNativeApp) {
                forgotPasswordUrl = gap.FullyQualifyRelativeLink(forgotPasswordUrl);
                gap.ExecCommand('hsn://HSNWebView.Goto//' + encodeURIComponent(forgotPasswordUrl));
            }
            else {
                window.location = forgotPasswordUrl;
            }
        });
        modal.application.Events.On(Events.Widget.Signin.NEW_CUSTOMER_INITIATED, function () {
            closeModal(modal);
            var createAccountUrl = modal.isCheckout ? '/checkout/account/create' : '/account/create';
            if (modal.deviceInformation.IsNativeApp) {
                createAccountUrl = gap.FullyQualifyRelativeLink(createAccountUrl);
                gap.ExecCommand('hsn://HSNWebView.Goto//' + encodeURIComponent(createAccountUrl));
            }
            else {
                window.location = createAccountUrl;
            }
        });
        modal.application.Events.On(Events.Widget.Signin.COMPLETE, function (data) {
            if (modal.deviceInformation.IsNativeApp) {
                var url = gap.FullyQualifyRelativeLink(data.returnUrl);
                gap.ExecCommand('hsn://HSNWebView.Goto//' + encodeURIComponent(url));
            }
            else {
                window.location = data.returnUrl;
            }
        });
    }

    function closeModal(modal) {
        modal.Hide();
    }

    SignInModal.prototype._show = function (isCheckout, doCommunity, config) {
        var scope = this;
        scope.AddLoadingSpinner();
        scope.isCommunity = typeof doCommunity != 'undefined' ? doCommunity : false;
        scope.isCheckout = typeof isCheckout != 'undefined' ? isCheckout : false;
        if (typeof config != 'undefined' && config != null) {
            modalCallback = config.callback;
        }

        let signinWidgetPromise = import(/* webpackChunkName: "WidgetSignin" */ 'HSNDIR/Widget/Signin.js');
            
        let ajax = $.ajax('/signin?ts=' + new Date().getTime(),
            {
                context: this,
                dataType: 'html',
                data: { isCommunity: scope.isCommunity, isCheckout: scope.isCheckout },
            }
        );

        Promise.all([ajax, signinWidgetPromise]).then(([data, SigninWidget]) => {
            scope.RemoveLoadingSpinner();
            var __scope = this;
            __scope.Root.find('#modal-loading').remove();
            this.Content.showHtml(
                data,
                0,
                function () {
                    __scope.Center();
                    __scope.Content.animate({ opacity: 1 });
                },
                function () {
                }
            );
        })
        .catch((x) => {
            alert("Unfortunately there was an error attempting to load the content, please try again.");
            scope.RemoveLoadingSpinner();
            scope.Hide();
        });
    };
    return SignInModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/Modals/SigninModal.js